import { Form, Typography } from "antd";
import AppContent from "common/AppContent";
import AppPageHeader from "common/PageHeader";
import ExtraContent from "components/Configuration/CommonComponents/ExtraContent";
import InvoiceForm from "../InvoiceForm";
// Antd Constants
const { Title } = Typography;
export default function ExportInvoiceExpenseView() {
  const [form] = Form.useForm();

  return (
    <>
      <AppContent
        header={
          <AppPageHeader
            extra={
              <ExtraContent hideFilterButton hideAddButton showBackButton />
            }
            title={<Title level={5}>Export Invoice Expense View</Title>}
          />
        }
        content={
          <>
            <InvoiceForm form={form} mode="view" />
          </>
        }
      />
    </>
  );
}
